/** A person's monthly allowance of personalised sessions, as the API reports it. */
export type UserAllowance = {
  hasSubscription: boolean;
  hasPremium: boolean;
  total: number;
  used: number;
  remaining: number;
  periodStart: Date | null;
  resetsOn: Date | null;
};

export type UserAllowanceDto = {
  has_subscription: boolean;
  has_premium: boolean;
  total: number;
  used: number;
  remaining: number;
  period_start?: string | null;
  resets_on?: string | null;
};

export function toUserAllowance(dto: UserAllowanceDto | null | undefined): UserAllowance | undefined {
  if (!dto) return undefined;
  return {
    hasSubscription: dto.has_subscription,
    hasPremium: dto.has_premium,
    total: dto.total,
    used: dto.used,
    remaining: dto.remaining,
    periodStart: dto.period_start ? new Date(dto.period_start) : null,
    resetsOn: dto.resets_on ? new Date(dto.resets_on) : null,
  };
}
